<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
  >
    <VersionPickerContainer
      v-show="modeShowInfo"
      :item="item"
      :meta="meta"
      :item-exists="itemExists"
      :show-button-new-version="isCreateNewVersion && itemExists"
      :show-button-update="isUpdateVersion && itemExists"
      @new-version="setMode('newVersion')"
      @update="setMode('update')"
    >
      <Box>
        <h2>{{ item.name }}</h2>
        <BaseTable>
          <BaseTableHead>
            <BaseTableRow
              label="Meta"
              title
            />
          </BaseTableHead>
          <BaseTableGroup>
            <BaseTableRow label="ID / Navn">
              {{ item.name }}
            </BaseTableRow>
            <BaseTableRow label="Publiceringsdato">
              {{ item.publishDate | HumanDate }}
            </BaseTableRow>
            <BaseTableRow label="Version">
              {{ item.versionNumber }}
            </BaseTableRow>
            <BaseTableRow label="Redigeret af">
              {{ item.updatedBy }}
            </BaseTableRow>
            <BaseTableRow label="Udsend notifikation">
              {{ item.sendNotification | IsTrue }}
            </BaseTableRow>
          </BaseTableGroup>
        </BaseTable>

        <BaseTable>
          <BaseTableHead>
            <BaseTableRow
              label="Detaljer"
              title
            />
          </BaseTableHead>
          <BaseTableGroup>
            <BaseTableRow label="Status">
              {{ item.deleted | IsDeleted }}
            </BaseTableRow>
            <BaseTableRow label="Ikon">
              <DisplayIcon :id="item.iconID" />
            </BaseTableRow>
            <BaseTableRow label="Overskrift">
              {{ item.headline }}
            </BaseTableRow>
            <BaseTableRow label="Beskrivelse">
              <p
                class="details__value"
                v-html="item.description"
              />
            </BaseTableRow>
            <BaseTableRow label="Links">
              <DisplayLinks :links="item.links" />
            </BaseTableRow>
          </BaseTableGroup>
        </BaseTable>
      </Box>
    </VersionPickerContainer>

    <section v-if="modeUpdate">
      <Box>
        <UpdateGlobalNotes
          :form="item"
          :action="mode"
          @saved="onSaved"
          @close="setMode('show')"
        />
      </Box>
    </section>
  </Page>
</template>

<script>
import DisplayLinks from '../../components/DisplayLinks.vue';
import BaseTableHead from '../../components/BaseTable/BaseTableHead.vue';
import BaseTableRow from '../../components/BaseTable/BaseTableRow.vue';
import BaseTableGroup from '../../components/BaseTable/BaseTableGroup.vue';
import BaseTable from '../../components/BaseTable/BaseTable.vue';
import VersionPickerContainer from '../../components/VersionPickerContainer.vue';
import Page from '../Page.vue';
import Box from '../../components/Box.vue';
import DisplayIcon from '../../components/DisplayIcon.vue';
import UpdateGlobalNotes from '../../components/Forms/GlobalNotes/UpdateGlobalNotes.vue';
import Pageload from '../../mixins/Pageload';
import ShowSingleVersion from '../../mixins/ShowSingleVersion';
import GlobalNotesService from '../../services/GlobalNotesService';
import IsTrue from '../../filters/isTrue';

export default {
    name: 'SingleGlobalNote',
    components: {
        UpdateGlobalNotes, Page, Box, DisplayIcon, VersionPickerContainer, BaseTable, BaseTableGroup, BaseTableRow, BaseTableHead, DisplayLinks,
    },
    mixins: [Pageload, ShowSingleVersion],
    filters: { IsTrue },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            service: GlobalNotesService,
        };
    },
};
</script>
